import React from 'react';
import './Header.css';
import logo from '../../img/Universidad-europea-logo.png';
import { useNavigate } from 'react-router-dom';

const Header = () => {
    const navigate = useNavigate();

    return (
        <header className="header-container">
            <div className="header-content">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <a href="javascript:void(0)">
                        <img src={logo} alt="Logo" width='250' onClick={() => { navigate(`/home`) }}/>
                    </a>
                </div>
                <div>
                    <p className='header-text'>Visor de informes</p>
                </div>
            </div>
        </header>
      );
};

export default Header;